module.exports = __webpack_public_path__ + "static/img/home_productcard_roof_mobile.df937de2.jpg";